import { render, staticRenderFns } from "./ExternalProductDialog.vue?vue&type=template&id=4218f082&scoped=true&"
import script from "./ExternalProductDialog.vue?vue&type=script&lang=js&"
export * from "./ExternalProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExternalProductDialog.vue?vue&type=style&index=0&id=4218f082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4218f082",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
